module.exports = __webpack_public_path__ + "static/media/banner4.8bb9cca5.jpg";